"use strict";
// Stremio Plus: localStorage seen by the core.
// Keys holding per-viewer data are suffixed with the profile id for secondary profiles,
// so every profile keeps its own local library, notifications and search history.
// The main profile keeps the original keys, compatible with stock Stremio Web.
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearSecondaryProfilesStorage = void 0;
var activeProfile_1 = require("./activeProfile");
var PROFILE_SCOPED_KEYS = [
    'library',
    'library_recent',
    'notifications',
    'calendar',
    'search_history',
];
var scopeKey = function (key) {
    var profile = (0, activeProfile_1.getActiveProfile)();
    if (profile === null || profile.isMain || !PROFILE_SCOPED_KEYS.includes(key))
        return key;
    return "".concat(key, ":").concat(profile.id);
};
var profileStorage = {
    getItem: function (key) { return localStorage.getItem(scopeKey(key)); },
    setItem: function (key, value) { return localStorage.setItem(scopeKey(key), value); },
    removeItem: function (key) { return localStorage.removeItem(scopeKey(key)); },
};
// Drops the local copies of every secondary profile (used on logout).
var clearSecondaryProfilesStorage = function () {
    Object.keys(localStorage)
        .filter(function (key) { return PROFILE_SCOPED_KEYS.some(function (scoped) { return key.startsWith("".concat(scoped, ":")); }); })
        .forEach(function (key) { return localStorage.removeItem(key); });
};
exports.clearSecondaryProfilesStorage = clearSecondaryProfilesStorage;
exports.default = profileStorage;
